// import React from "react";
// export default function AppCTA() {
//   return (
//     <section className="bg-gradient-to-r from-amber-400 to-pink-400">
//       <div className="mx-auto max-w-7xl px-4 py-10 md:py-14 grid md:grid-cols-2 items-center gap-6">
//         <div>
//           <h3 className="text-2xl md:text-3xl font-black text-slate-900">Download Our Mobile App</h3>
//           <p className="mt-2 text-slate-900/80 max-w-xl">
//             Book tickets on the go. Discover events nearby. Secure payments.
//           </p>
//           <div className="mt-4 flex items-center gap-3">
//             <button className="rounded-xl bg-black text-white px-4 py-3 text-sm font-semibold">Get it on Google Play</button>
//             <button className="rounded-xl bg-black text-white px-4 py-3 text-sm font-semibold">Download on App Store</button>
//           </div>
//         </div>
//         <div className="justify-self-center">
//           <img
//             src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=800&auto=format&fit=crop"
//             alt="App"
//             className="h-64 w-40 object-cover rounded-[28px] shadow-2xl border-4 border-white/40"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }


import React from "react";
import mobileMockup from "../assets/showtimemobile.png";

/** Beautiful mobile-app CTA with store badges and a floating phone */
export default function AppCTA() {
  return (
    <section className="relative px-4 py-12 md:px-8 md:py-16 font-sans overflow-hidden">
      <div className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-[40px] bg-slate-950 px-6 py-12 shadow-2xl sm:px-12 md:py-16">
          
          {/* Animated Background Gradients & Orbs */}
          <div className="absolute -left-32 -top-32 h-[400px] w-[400px] rounded-full bg-amber-500/20 blur-[100px]" />
          <div className="absolute -bottom-32 -right-32 h-[400px] w-[400px] rounded-full bg-fuchsia-500/20 blur-[100px]" />
          
          {/* Subtle noise/grid texture */}
          <div 
            className="absolute inset-0 opacity-[0.03] mix-blend-overlay pointer-events-none"
            style={{ backgroundImage: "url('https://www.transparenttextures.com/patterns/cubes.png')" }}
          />

          <div className="relative z-10 grid items-center gap-12 lg:grid-cols-2">
            
            {/* Left Column: Typography */}
            <div className="text-center lg:text-left">
              <h2 className="mt-6 text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl leading-[1.15]">
                Your city's vibe,<br className="hidden lg:block" />
                <span className="bg-gradient-to-r from-amber-400 to-rose-400 bg-clip-text text-transparent">
                  {" "}in your pocket.
                </span>
              </h2>
              
              <p className="mt-4 text-base text-slate-400 max-w-lg mx-auto lg:mx-0 leading-relaxed">
                Experience ShowtimeBro like never before. Get personalized event recommendations, lightning-fast checkout, and offline QR tickets.
              </p>

              {/* Social Proof */}
              <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <div className="flex -space-x-3">
                  <img src="https://i.pravatar.cc/100?img=1" alt="user" className="h-8 w-8 rounded-full border-2 border-slate-950" />
                  <img src="https://i.pravatar.cc/100?img=2" alt="user" className="h-8 w-8 rounded-full border-2 border-slate-950" />
                  <img src="https://i.pravatar.cc/100?img=3" alt="user" className="h-8 w-8 rounded-full border-2 border-slate-950" />
                  <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-slate-950 bg-slate-800 text-[10px] font-bold text-white">+12k</div>
                </div>
                <div className="text-sm font-medium text-slate-300 pl-1">
                  <div className="flex items-center gap-1 text-amber-400 mb-0.5">
                    <StarRating rating={5} />
                  </div>
                  Loved by users
                </div>
              </div>
              
              {/* Badges */}
              <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <a 
                  href="https://play.google.com/store/apps/details?id=com.nagarsoftwaresolution.showtimebro&pcampaignid=web_share" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="group flex items-center gap-3 rounded-[14px] bg-amber-500 border border-amber-400 px-5 py-3 transition-all hover:bg-amber-400 hover:scale-105 hover:shadow-[0_0_24px_rgba(251,191,36,0.4)] text-slate-950"
                >
                  <PlayLogo />
                  <div className="text-left">
                    <div className="text-[10px] font-bold text-slate-800 leading-none uppercase tracking-wide">Download our App</div>
                    <div className="text-[15px] font-extrabold leading-snug">GET IT ON Google Play</div>
                  </div>
                </a>
              </div>
            </div>

            {/* Right Column: Phone Mockup */}
            <div className="relative mx-auto mt-10 w-full max-w-[220px] sm:max-w-[240px] lg:mt-0 lg:max-w-[260px]">
              {/* Outer Glow */}
              <div className="absolute inset-0 -m-6 rounded-full bg-gradient-to-tr from-amber-500/20 to-rose-500/20 blur-[50px]" />
              
              <div className="group relative">
                {/* Hardware Mockup */}
                <div className="relative z-10 rounded-[38px] border-[6px] border-slate-900 bg-slate-900 shadow-2xl transition-transform duration-700 ease-out group-hover:-translate-y-3 group-hover:rotate-2">
                  {/* Notch */}
                  <div className="absolute left-1/2 top-0 z-20 h-5 w-24 -translate-x-1/2 rounded-b-[14px] bg-slate-900" />
                  
                  {/* Screen Content */}
                  <div className="relative aspect-[9/19.5] overflow-hidden rounded-[30px] bg-slate-800">
                    <img
                      src={mobileMockup}
                      alt="App Interface"
                      className="h-full w-full object-cover opacity-90 transition-transform duration-1000 group-hover:scale-110"
                    />
                    {/* Glass Reflection */}
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-white/5" />
                  </div>
                </div>

                {/* Floating Chips */}


                <div className="absolute -right-10 bottom-1/4 z-20 animate-[float_5s_ease-in-out_infinite_reverse]">
                  <div className="flex items-center gap-1.5 rounded-xl border border-white/10 bg-white/10 px-3 py-2 backdrop-blur-md shadow-2xl">
                    <span className="text-base">⚡</span>
                    <span className="text-xs font-bold text-white">1-Click Booking</span>
                  </div>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </section>
  );
}

/* ---------------- small pieces ---------------- */
function Chip({ icon, children }) {
  return (
    <div className="select-none rounded-full bg-white/80 px-3 py-1 text-xs font-semibold text-slate-800 ring-1 ring-black/5 backdrop-blur">
      <span className="mr-1">{icon}</span>
      {children}
    </div>
  );
}

function StarRating({ rating = 5 }) {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);

  return (
    <div className="inline-flex items-center">
      {Array.from({ length: full }).map((_, i) => (
        <Star key={`f-${i}`} className="text-amber-600" />
      ))}
      {half && <StarHalf className="text-amber-600" />}
      {Array.from({ length: empty }).map((_, i) => (
        <Star key={`e-${i}`} className="text-slate-400" />
      ))}
    </div>
  );
}

function Star({ className = "" }) {
  return (
    <svg className={`h-4 w-4 ${className}`} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l2.9 6.26L22 9.27l-5 4.87L18.2 22 12 18.7 5.8 22l1-7.86-5-4.87 7.1-1.01L12 2z" />
    </svg>
  );
}
function StarHalf({ className = "" }) {
  return (
    <svg className={`h-4 w-4 ${className}`} viewBox="0 0 24 24">
      <defs>
        <linearGradient id="halfGrad">
          <stop offset="50%" stopColor="currentColor" />
          <stop offset="50%" stopColor="transparent" />
        </linearGradient>
      </defs>
      <path
        d="M12 2l2.9 6.26L22 9.27l-5 4.87L18.2 22 12 18.7 5.8 22l1-7.86-5-4.87 7.1-1.01L12 2z"
        fill="url(#halfGrad)"
        stroke="currentColor"
        strokeWidth="0"
      />
    </svg>
  );
}

function PlayLogo() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.61 3 21.09 3 20.5ZM14.4 11.29L4.85 1.74C5.19 1.55 5.6 1.5 5.98 1.7L18.86 8.92L14.4 11.29ZM15.11 12L19.57 14.37L22.25 12.85C22.87 12.5 22.87 11.5 22.25 11.15L19.57 9.63L15.11 12ZM14.4 12.71L18.86 15.08L5.98 22.3C5.6 22.5 5.19 22.45 4.85 22.26L14.4 12.71Z" />
    </svg>
  );
}
function AppleLogo() {
  return (
    <svg className="h-6 w-6" viewBox="0 0 256 315" fill="currentColor" aria-hidden="true">
      <path d="M213.1 167.7c-.5-53 43.2-78.1 45.2-79.4-24.6-36-62.8-41-76.3-41.6-32.5-3.3-63.4 19.2-79.9 19.2-16.7 0-42-18.7-69.2-18.2-35.6.5-68.5 20.7-86.8 52.5-37.1 64.3-9.4 158.9 26.7 210.9 17.8 25.7 39 54.6 66.7 53.6 26.8-1 36.9-17.3 69.1-17.3 31.9 0 41.6 17.3 69.4 16.8 28.7-.5 47-26.3 64.9-52.1 20.3-29.7 28.6-58.4 29.1-59.9-.6-.3-55.8-21.4-56.1-84.5zM172.6 54.8C186.2 38.6 195.3 16 192.8 0 176.1.7 153.4 10.6 140 26.8 127.7 41.8 118.2 64.9 121.3 86.1c20.2 1.6 40.9-10.3 51.3-31.3z"/>
    </svg>
  );
}
